import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=23f5d0df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23f5d0df"]])

export default __exports__